module.exports = __webpack_public_path__ + "img/u17768.5dfad576.png";